import { createContainer } from 'unstated-next';
import { useState } from 'react';
import createDebug from 'debug';
import { makeRequest } from 'core/user/request-helper';
import { userManager } from '../../../config';

const debug = createDebug('evp:authenticated');

export type AuthenticatedState =
  | 'unknown'
  | 'authenticated'
  | 'unauthenticated';
type Return = [AuthenticatedState, (newState: AuthenticatedState) => void];

function useAuthenticatedState(): Return {
  const [authenticated, setAuthenticated] =
    useState<AuthenticatedState>('unknown');

  function update(newState: AuthenticatedState): void {
    setAuthenticated(newState);
  }

  return [authenticated, update];
}

export async function authenticate(): Promise<AuthenticatedState> {
  debug('Checking authentication state for user...');
  const auth = await userManager.getUser();
  // check whether our cookie is valid
  const res = await makeRequest('/loggedin', undefined, 'GET');

  let state: AuthenticatedState = 'unknown';

  if (res.status === 204 || res.status === 200) {
    state = 'authenticated';
  } else if (res.status === 401) {
    state = 'unauthenticated';
  }

  debug(
    'Marking the user authentication status as `%s` (got %d status code)',
    state,
    res.status,
  );
  return state;
}

const container = createContainer<Return, AuthenticatedState>(
  useAuthenticatedState,
);
const useAuthenticated = container.useContainer;

export const AuthenticatedProvider = container.Provider;
export default useAuthenticated;
